import { render, staticRenderFns } from "./CustomerPersonelPage.vue?vue&type=template&id=146d0567&"
import script from "./CustomerPersonelPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPersonelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports